import orderService from "@/services/OrderService";

const deliveryMethodList = {
    namespaced: true,
    state: {
        deliveryMethods: [],
        loading: false,
    },
    mutations: {
        SET_DELIVERY_METHODS(state, deliveryMethods) {
            state.deliveryMethods = deliveryMethods
        },
        SET_LOADING(state, loading) {
            state.loading = loading
        }
    },
    actions: {
        load(context) {
            context.commit("SET_LOADING", true);
            const params = {
                pagination: {page: 1, itemsPerPage: 999},
                sorting: {sortBy: ["name"], sortDesc: [false]},
                search: context.state.search
            };

            return orderService.deliveryMethods.list(params)
                .then(json => {
                    context.commit("SET_DELIVERY_METHODS", json.items);
                })
                .catch(err => {
                    console.log(err);
                })
                .finally(() => {
                    context.commit("SET_LOADING", false);
                });

        },
    },
    getters: {
        byIri: (state) => (iri) => {
            if (state.deliveryMethods) {
                return state.deliveryMethods.find(item => item['@id'] === iri)
            }
        },
        loading: (state) => {
            return state.loading
        }
    }
};

export default deliveryMethodList;
